module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.11761/img/storefront-header-blobs.svg"